module.exports = __webpack_public_path__ + "img/full1-min.c81b949a.png";